
export const BinanceChainID = {
  "97": "bnb",
  "56": "Binance",
  "1": "main",
  "42": "kovan"
}
